<div class="vitals-container">
  <div class="form-table-container">
    <app-vitals-form class="vitals-form" (newVitalEvent)="addVital($event)"> </app-vitals-form>

    <p-table #dt class="vitals-table" [value]="vitals" styleClass="p-datatable" [rowHover]="true" [rows]="5"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 25]" responsiveLayout="scroll" [paginator]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} vitals" [filterDelay]="0">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="date">
            <div class="flex justify-content-between align-items-center">
              Date/Time
              <p-sortIcon field="dateCreated"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="heartRate">
            <div class="flex justify-content-between align-items-center">
              Heart Rate (bpm)
              <p-sortIcon field="heartRate"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="oxySat">
            <div class="flex justify-content-between align-items-center">
              Oxygen Saturation (%)
              <p-sortIcon field="oxySat"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="oxygen">
            <div class="flex justify-content-between align-items-center">
              Oxygen
              <p-sortIcon field="oxygen"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="oxygenInput">
            <div class="flex justify-content-between align-items-center">
              Oxygen Input
              <p-sortIcon field="oxygen"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="respirations">
            <div class="flex justify-content-between align-items-center">
              Respirations
              <p-sortIcon field="respirations"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="temp">
            <div class="flex justify-content-between align-items-center">
              Temperature (°C)
              <p-sortIcon field="temperature"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="systolic">
            <div class="flex justify-content-between align-items-center">
              Systolic
              <p-sortIcon field="systolic"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="diastolic">
            <div class="flex justify-content-between align-items-center">
              Diastolic
              <p-sortIcon field="diastolic"></p-sortIcon>
            </div>
          </th>
          <th>
            <div class="flex justify-content-between align-items-center">
              <div>Actions</div>
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-vital>
        <tr class="p-selectable-row">
          <td>
            {{ vital.dateString }}
          </td>
          <td>
            <span [ngStyle]="{
                color: vital.isHeartRateWithinNormalRange ? '#495057' : 'red'
              }">{{ vital.heartRate }}</span>
          </td>
          <td>
            <span [ngStyle]="{
                color: vital.isOxySatWithinNormalRange ? '#495057' : 'red'
              }">{{ vital.oxySat }}</span>
          </td>
          <td>
            {{ vital.oxygen }}
          </td>
          <td>{{ vital.oxygenInput }} {{ vital.oxygenInputUnit }}</td>
          <td>
            <span [ngStyle]="{
                color: vital.isRespirationsWithinNormalRange ? '#495057' : 'red'
              }">{{ vital.respirations }}</span>
          </td>
          <td>
            <span [ngStyle]="{
                color: vital.isTemperatureWithinNormalRange ? '#495057' : 'red'
              }">{{ vital.temp }}</span>
          </td>
          <td>
            <span [ngStyle]="{
                color: vital.isSystolicWithinNormalRange ? '#495057' : 'red'
              }">{{ vital.systolic }}</span>
          </td>
          <td>
            <span [ngStyle]="{
                color: vital.isDiastolicWithinNormalRange ? '#495057' : 'red'
              }">{{ vital.diastolic }}</span>
          </td>
          <td class="actions-container">
            <button pButton type="button" class="p-button-primary" icon="pi pi-pencil" pTooltip="Edit vital"
              (click)="editVital(vital)"></button>
            <button pButton type="button" class="p-button-danger" icon="pi pi-trash" pTooltip="Delete vital"
              (click)="deleteVital(vital)"></button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">No vitals found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="vitals-chart">
    <app-vitals-chart [data]="vitals" [viewableVitals]="viewableVitals"> </app-vitals-chart>
  </div>
</div>